import { render } from "./UserProfileTemplate.vue?vue&type=template&id=33247002"
import script from "./UserProfileTemplate.vue?vue&type=script&lang=js"
export * from "./UserProfileTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script